import type { ConversationId } from "PFCore/services/propilot";
import { useEffect, useRef } from "react";

const STORAGE_KEY = "propilot.conversationId";

const getOrCreateConversationId = (): ConversationId => {
  const existing = sessionStorage.getItem(STORAGE_KEY);
  return existing ?? crypto.randomUUID();
};

export const useSessionConversationId = (enabled: boolean): ConversationId => {
  const idRef = useRef<ConversationId | null>(null);
  if (idRef.current === null) {
    idRef.current = getOrCreateConversationId();
  }

  useEffect(() => {
    if (!enabled) {
      return;
    }
    sessionStorage.setItem(STORAGE_KEY, idRef.current!);
  }, [enabled]);

  return idRef.current;
};

export const clearSessionConversationId = (): void => {
  sessionStorage.removeItem(STORAGE_KEY);
};
